import { useSelector } from "react-redux";
import { ROLE_ADMIN } from "redux/constants/Auth";

const useAuth = (props) => {
  const UserRoles = useSelector((state) => state.auth.roles);
  const [AuthNeeded] = props;
  if (!UserRoles) {
    return {
      userRoles: [],
      isAuth: false,
      exact: false,
      adminstration: false,
    };
  }

  if (UserRoles.indexOf(ROLE_ADMIN) !== -1) {

    return {
      userRoles: UserRoles,
      isAuth: true,
      exact: AuthNeeded && AuthNeeded.length === 1 && UserRoles.includes(AuthNeeded[0].toUpperCase()),
      adminstration: true,
    };
  }






  var authentication = false;

  if (Array.isArray(AuthNeeded)) {
    const normalizedAuthNeeded = AuthNeeded.map(role => role.toUpperCase());
    authentication = UserRoles.some(UserRole => {
      return normalizedAuthNeeded.includes(UserRole);
    });
  } else {
    authentication = UserRoles.includes(AuthNeeded.toUpperCase());
  }

  return {
    userRoles: UserRoles,
    isAuth: authentication,
    exact: AuthNeeded && AuthNeeded.length === 1 && UserRoles.includes(AuthNeeded[0].toUpperCase()),
    adminstration: UserRoles.indexOf(ROLE_ADMIN) !== -1,
  };
};


export default useAuth;
